export default __webpack_public_path__ + "static/media/french-flag.df673bb2.png";